import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { grid } from '@noths/polaris-client-ribbons-base';
import * as styles from "./ProductCarouselSkeleton.styles";
import { SkeletonCard } from "../../elements/Loaders/Skeletons/components/SkeletonCard";
import { SkeletonLabel } from "../../elements/Loaders/Skeletons/components/SkeletonLabel";
import * as imageStyles from "../../../styles/image";
export var ProductCarouselSkeleton = function ProductCarouselSkeleton(_ref) {
  var _ref$numberOfItems = _ref.numberOfItems,
    numberOfItems = _ref$numberOfItems === void 0 ? 6 : _ref$numberOfItems;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledHeader, {
    $_css: [styles.header]
  }, /*#__PURE__*/React.createElement(_StyledSkeletonLabel, {
    labelHeight: "MD",
    $_css2: imageStyles.imageWidth.regular
  })), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css3: [grid, styles.carousel]
  }, Array.from({
    length: numberOfItems
  }).map(function (_, key) {
    return /*#__PURE__*/React.createElement(_StyledDiv2, {
      key: key,
      $_css4: imageStyles.imageWidth.regular
    }, /*#__PURE__*/React.createElement(SkeletonCard, {
      cropImageForMobile: false
    }));
  })));
};
var _StyledHeader = _styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSkeletonLabel = _styled2(SkeletonLabel)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = /*#__PURE__*/_styled4("div").withConfig({
  displayName: "ProductCarouselSkeleton___StyledDiv2",
  componentId: "sc-u8pxwu-0"
})(["", ""], function (p) {
  return p.$_css4;
});